import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function PageLoader() {
  const { t } = useTranslation()

  return (
    <div className="flex h-full min-h-400 flex-col items-center justify-center gap-4">
      <Loader2 className="size-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">{t('loading')}</p>
    </div>
  )
}
